import { lazy } from 'solid-js'
import { messages } from '../../pages/home-page/home-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/home-page/home-page.jsx')),
    descriptionMessage: messages.guestDescriptionMessage,
    path: '/',
    titleMessage: messages.guestTitleMessage,
}
